module.exports = __webpack_public_path__ + "img/CANAM_G.df4644bc.png";